var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5a4 4 0 0 1 4-4h8.343a4 4 0 0 1 2.829 1.172l1.656 1.656A4 4 0 0 1 21 6.657V19a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V5Zm16 3v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7v2a3 3 0 0 0 3 3h2Zm-.11-2a2 2 0 0 0-.476-.757l-1.657-1.657A2 2 0 0 0 16 3.11V5a1 1 0 0 0 1 1h1.89Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9ZM9 16a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H9Z",
    fill: "#777E91"
  })));
};
export default SvgLine;